/* istanbul ignore file */
import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const stanPlugin = createPlugin({
  id: "stan",
  routes: {
    root: rootRouteRef,
  },
});

export const StanPage = stanPlugin.provide(
  createRoutableExtension({
    name: "StanPage",
    component: () => import("./router").then((m) => m.Router),
    mountPoint: rootRouteRef,
  })
);
